export const print_detail_list = () => ([
    {
        _id: "config.due",
        label: "Order Due Date",
        enabled: true,
    },
    {
        _id: "status",
        label: "Order Status",
        enabled: false,
    },
    {
        _id: "config.service",
        label: "Order Service",
        enabled: true,
    },
    {
        _id: "created",
        label: "Order Placed",
        enabled: false,
    },
    {
        _id: "ready_in",
        label: "Order Est. Ready Time",
        enabled: true,
    },
    {
        _id: "pickup_in",
        label: "Order Est. Driver Pickup Time",
        enabled: false,
    },
    {
        _id: "delivery_in",
        label: "Order Est. Delivery Time",
        enabled: true,
    },
    {
        _id: "payment.method",
        label: "Payment Method",
        enabled: true,
    },
    {
        _id: "payment.currency",
        label: "Payment Currency (Multi-currency stores only)",
        enabled: true,
    },
    {
        _id: "payment.status",
        label: "Payment Status (Online Payments)",
        enabled: true,
    },
    {
        _id: "notes",
        label: "Customer Notes",
        enabled: true,
    },
    {
        _id: "config.table",
        label: "Table Name (Dine-In)",
        enabled: true,
    },
    {
        _id: "config.number_of_people",
        label: "Number Of People (Dine-In)",
        enabled: true,
    },
    {
        _id: "config.destination",
        label: "Delivery Address",
        enabled: true,
    },
    {
        _id: "config.zone",
        label: "Delivery Zone",
        enabled: true,
    },
    {
        _id: "config.distance",
        label: "Delivery Distance (km)",
        enabled: true,
    },
    {
        _id: "config.driving_time",
        label: "Delivery Driving Time (minutes)",
        enabled: true,
    },
    {
        _id: "config.tookan",
        label: "Tookan Delivery Booking Status",
        enabled: true,
    },
    {
        _id: "customer.name",
        label: "Customer Name",
        enabled: false,
    },
    {
        _id: "customer.email",
        label: "Customer Email",
        enabled: false,
    },
    {
        _id: "customer.phone",
        label: "Customer Phone",
        enabled: true,
    },
]);
export const ESCPOSFontSizes = [
    { value: "1", label: "1 (Default)" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
];
export const print_detail_list_customer = () => print_detail_list().map((item) => {
    const disabledOptions = [
        "status",
        "pickup_in",
        "config.zone",
        "config.distance",
        "config.driving_time",
        "config.tookan",
        "custom.checkout.1",
        "custom.checkout.2"
    ];
    const isEnabled = disabledOptions.indexOf(item._id) === -1;
    return {
        ...item,
        enabled: isEnabled,
    };
});
//# sourceMappingURL=printing.js.map